/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
import { Component, OnInit } from '@angular/core';
import {
  faBars,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faTimes,
  faUser,
  faUsers
} from '@fortawesome/pro-regular-svg-icons';

@Component({
  selector: 'app-setting',
  templateUrl: './setting.component.html',
  styleUrls: ['./setting.component.scss'],
  standalone: false
})
export class SettingComponent implements OnInit {
  faChevronRight = faChevronRight;
  faChevronDown = faChevronDown;
  faUser = faUser;
  faUsers = faUsers;
  faTimes = faTimes;
  faBars = faBars;

  generalMenuOpen = true;
  sideMenuExpand = true;

  constructor() {}

  ngOnInit(): void {
    const sideMenustatus = sessionStorage.getItem('sideMenuExpanded');
    if (sideMenustatus == null) {
      this.sideMenuExpand = true;
    } else {
      this.sideMenuExpand = JSON.parse(sideMenustatus);
    }
  }
  hasClass(el: any) {
    return !(el.getAttribute('class') && el.getAttribute('class').indexOf('active_item') !== -1);
  }

  sideMenuToggled() {
    this.sideMenuExpand = !this.sideMenuExpand;
    sessionStorage.setItem('sideMenuExpanded', this.sideMenuExpand.toString());
  }
}
